var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 35.053 34.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.317,29.221c-.351,0-.697-.119-.984-.351-1.204-.97-3.483-2.789-4.725-3.781l-.245-.195c-.65-.518-1.023-1.293-1.023-2.127v-3.645c0-.416-.158-.811-.443-1.112L5.664,8.265c-.899-.898-1.405-2.116-1.405-3.41C4.259,2.178,6.437,0,9.114,0h21.084c2.677,0,4.855,2.178,4.855,4.854,0,1.146-.407,2.253-1.149,3.13-.026.035-.054.069-.084.102l-9.241,9.92c-.441.474-.685,1.092-.685,1.739v7.898c0,.612-.343,1.156-.895,1.421-.219.104-.452.156-.683.156ZM9.114,2.174c-1.479,0-2.681,1.203-2.681,2.681,0,.713.28,1.385.789,1.894l9.252,9.766c.67.707,1.04,1.634,1.04,2.608v3.645c0,.168.075.323.205.427l.247.197c.958.765,2.532,2.021,3.756,3.002v-6.647c0-1.199.45-2.343,1.268-3.222l9.179-9.854c.013-.017.026-.032.04-.048.434-.491.672-1.119.672-1.768,0-1.478-1.203-2.681-2.681-2.681H9.114Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.059,34.935c-.351,0-.697-.119-.984-.351-1.204-.97-3.483-2.789-4.725-3.781l-.245-.195c-.65-.518-1.023-1.293-1.023-2.127v-3.645c0-.416-.158-.812-.443-1.112L1.406,13.979c-.899-.897-1.406-2.116-1.406-3.41,0-1.559.761-3.034,2.036-3.947.487-.351,1.167-.238,1.517.251.35.488.237,1.167-.251,1.517-.706.506-1.128,1.32-1.128,2.18,0,.713.28,1.385.789,1.893l9.252,9.767c.67.707,1.039,1.633,1.039,2.608v3.645c0,.168.075.323.205.427l.247.197c.958.765,2.532,2.021,3.756,3.002v-2.451c0-.601.486-1.087,1.087-1.087s1.087.486,1.087,1.087v3.702c0,.612-.343,1.156-.895,1.421-.219.104-.452.156-.683.156ZM18.438,32.891h.01-.01Z",
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFilters);
export default __webpack_public_path__ + "static/media/ReportFilters.09d87cd6.svg";
export { ForwardRef as ReactComponent };